module.exports = __webpack_public_path__ + "img/gaoxinjishuqiyezhengshu.3ffe3efc.jpg";